export const BOOLEAN_ENUM_VALUES = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
} as const;
